import { Box, styled } from '@mui/material';

export const ActionsStyled = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
}) as typeof Box;

export const ActionsWrapperStyled = styled(Box)({
  alignSelf: 'center',
  width: '65%',
}) as typeof Box;

export const SwiperWrapperStyled = styled(Box)(({ theme }) => ({
  div: {
    '&.swiper-slide': {
      height: 'auto',
    },
    '&.swiper': {
      width: '100%',
    },
  },
  span: {
    '&.swiper-pagination-bullet': {
      background: 'none',
      border: `0.1rem solid ${theme.palette.grey[300]}`,
      opacity: '100%',
    },
    '&.swiper-pagination-bullet-active': {
      background: theme.palette.grey[300],
    },
  },
}));

export const BeneficiariesSectionStyled = styled(Box)(({ theme }) => ({
  paddingBottom: theme.spacing(4),
}));
